import Vue from 'vue'
import App from '~/components/main/App'
import vuetify from '~/plugins/vuetify'
import settings from "~/settings";
import router from "~/router";
import store from "~/store";
import DateTimePicker from "~/components/partials/DateTimePicker";
import VCalendar from 'v-calendar';
import CustomSelect from "~/components/partials/CustomSelect";
import DialogView from "~/components/partials/DialogView";
import CallInfo from "~/components/partials/Call/CallInfo";
import QualityInfo from "~/components/partials/QualityInfo";
import CaruselButton from "~/components/partials/CaruselButton";
import utils from "~/utils";
import VueApexCharts from 'vue-apexcharts'
import VueTheMask from 'vue-the-mask'

Vue.use(VCalendar, {
  componentPrefix: 'vc'
});
Vue.use(VueApexCharts)
Vue.use(VueTheMask)

Vue.component('apexchart', VueApexCharts)
Vue.component('DateTimePicker', DateTimePicker)
Vue.component('CustomSelect', CustomSelect)
Vue.component('DialogView', DialogView)
Vue.component('CallInfo', CallInfo)
Vue.component('QualityInfo', QualityInfo)
Vue.component('CaruselButton', CaruselButton)


Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.config.productionTip = false

Vue.prototype.$env = settings
Vue.prototype.utils = utils

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
